import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import OutlinedInput from '@mui/material/OutlinedInput'
import Select, { SelectProps } from '@mui/material/Select'
import { FormattedMessage } from 'react-intl'
import { StateControl } from '.'

export type SelectSearchFieldProps<T extends string = string> = SelectProps<
  T[]
> & {
  label: string
  stateControl: StateControl<T[]>
}

const SelectSearchField = <T extends string = string>(
  props: SelectSearchFieldProps<T>,
) => {
  const [value, setValue] = props.stateControl

  return (
    <FormControl sx={{ m: 1, width: '100%' }} size="small">
      <InputLabel
        sx={{
          overflow: 'visible',
          whiteSpace: 'nowrap',
        }}
        size="small"
        shrink={true}
      >
        {props.label}
      </InputLabel>
      <Select
        size="small"
        value={value}
        type="search"
        input={<OutlinedInput size="small" label={props.label} />}
        multiple
        onChange={(event) => {
          const value = event.target.value
          // If a string value is passed (autofill by browser), split it into an array
          if (typeof value === 'string') {
            setValue(value.split(',') as T[])
            return
          }
          setValue(value)
        }}
        displayEmpty={true}
        renderValue={(selected) => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            <FormattedMessage
              id="components.selectSearchField.selectedCountText"
              values={{ count: selected.length }}
            />
          </Box>
        )}
        {...props}
      >
        {props.children}
      </Select>
    </FormControl>
  )
}

export default SelectSearchField
